import { render, staticRenderFns } from "./email-verification-input.vue?vue&type=template&id=533e188c&scoped=true"
import script from "./email-verification-input.vue?vue&type=script&lang=js"
export * from "./email-verification-input.vue?vue&type=script&lang=js"
import style0 from "./email-verification-input.vue?vue&type=style&index=0&id=533e188c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533e188c",
  null
  
)

export default component.exports